import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.3.285a1 1 0 0 1 1.4 1.43L3.27 8H17.5a1 1 0 1 1 0 2H3.55l6.165 6.3a1 1 0 1 1-1.43 1.4l-8-8.179a1 1 0 0 1 .016-1.414z"
    }, null, -1)
  ]))]))
}
export default { render: render }